<template>
    <div class="rate-card-period-cell">
        <div v-if="isEditing" class="rate-card-period-cell__editor">
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                location="bottom start"
                :offset="[8, 0]"
            >
                <template #activator="{ props: menuProps }">
                    <button
                        v-bind="menuProps"
                        type="button"
                        class="rate-card-period-cell__activator my-1"
                    >
                        <span class="rate-card-period-cell__text">{{ displayPeriod }}</span>
                        <v-icon size="16" class="ml-3">custom:date_picker</v-icon>
                    </button>
                </template>
                <date-picker
                    :dates="dates"
                    :min="minDate"
                    :range="'range'"
                    @complete="onComplete"
                />
            </v-menu>
        </div>
        <span v-else>{{ params.getPeriod(params.data) }}</span>
    </div>
</template>

<script>
export default {
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dates: [],
            menu: false,
        };
    },
    computed: {
        isEditing() {
            return this.params.isEditing(this.params.data._id);
        },
        minDate() {
            return this.params.getMinDate(this.params.data);
        },
        displayPeriod() {
            return this.params.getPeriod({
                ...this.params.data,
                effectiveFrom: this.dates[0],
                effectiveTo: this.dates[1],
            });
        },
    },
    watch: {
        isEditing: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.syncDates();
                }
            },
        },
    },
    methods: {
        syncDates() {
            this.dates = [this.params.data.effectiveFrom, this.params.data.effectiveTo].filter(
                Boolean
            );
        },
        onComplete(nextDates) {
            if (!Array.isArray(nextDates) || nextDates.length < 2) {
                return;
            }

            const [effectiveFrom, effectiveTo] = nextDates;
            this.dates = [effectiveFrom, effectiveTo];
            this.params.node.data.effectiveFrom = effectiveFrom;
            this.params.node.data.effectiveTo = effectiveTo;
            this.params.onChange({
                id: this.params.data._id,
                fields: {
                    effectiveFrom,
                    effectiveTo,
                },
            });
            this.params.api.refreshCells({
                rowNodes: [this.params.node],
                columns: ['period'],
                force: true,
            });
            this.menu = false;
        },
    },
};
</script>

<style scoped lang="scss">
.rate-card-period-cell {
    width: 100%;

    &__editor {
        width: 100%;
    }

    &__activator {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1.8rem;
        width: 100%;
        min-height: 3.6rem;
        padding: 0.8rem 1.4rem;
        border: 1px solid rgba(0, 0, 0, 0.24);
        background: #fff;
        color: inherit;
        text-align: left;
    }

    &__text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    :deep(.v-icon) {
        margin-left: 0;
        flex-shrink: 0;
    }
}
</style>
